import React, {useEffect, useState} from 'react'
import Header from "../components/Header"
import BreadCrumbs from "../components/BreadCrumbs"
import Notification from "../components/Notification"
import {apiMy, apiSelfEdit} from "api-methods"
import '../css/EditCompany.css'
import {Loaders} from "../components/Loaders"
import {useLocation, useNavigate} from "react-router-dom"
import { handleAuthErrorAndRedirect, isSuccessStatus } from '../utils/authError'

const Personal = () => {

    const [userData, setUserData] = useState(null)
    const [formData, setFormData] = useState({name: '', family: '', phone: ''})
    const [notification, setNotification] = useState(null)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        apiMy()
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code)) {
                    if (typeof data.data === 'string') {
                        data.data = JSON.parse(data.data)
                    }

                    setUserData(data.data)
                    setFormData({
                        name: data.data.userName || '',
                        family: data.data.userLastName || '',
                        phone: data.data.userPhone || ''
                    })
                } else {
                    navigate('/login', {state: { from: location.pathname + location.search }})
                }
            })
            .catch(_ => {
            })
    }, [])

    const showNotification = (message, type = 'success') => {setNotification({ message, type })}
    const hideNotification = () => {setNotification(null)}

    const handleInputChange = (e) => {
        let { name, value } = e.target;

        // Обработка телефона
        if (name === 'phone') {
            // Удаляем все нецифровые символы, кроме плюса в начале
            value = value.replace(/[^\d+]/g, '');

            // Если строка пустая или начинается с +, оставляем как есть
            if (value === '' || value.startsWith('+')) {
                // Удаляем все плюсы кроме первого
                const plusCount = (value.match(/\+/g) || []).length;
                if (plusCount > 1) {
                    value = '+' + value.replace(/\+/g, '');
                }

                // Ограничиваем длину до 13 символов (1 знак + и 12 цифр)
                if (value.length > 13) {
                    value = value.substring(0, 13);
                }
            } else {
                // Если не начинается с +, добавляем его и ограничиваем цифры
                const digitsOnly = value.replace(/\D/g, '');
                value = '+' + digitsOnly.substring(0, 12);
            }
        }

        setFormData(prev => ({...prev, [name]: value}))
    }

    const handleSave = () => {
        const forApiReq = {
            userName: formData.name,
            userLastName: formData.family,
            phone: formData.phone
        }
        apiSelfEdit(forApiReq)
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location})) return
                if (isSuccessStatus(data.code)) {showNotification('Данные успешно сохранены!', 'success')} else {showNotification('Ошибка сохранения', 'error')}
            })
            .catch(_ => {showNotification('Ошибка сохранения', 'error')})
            .finally(_ => {})
    }

    if (!userData) {return <div className="loadersComponent"><Loaders /></div>}

    return <div className="pagePersonal">
        <Header/>
        <BreadCrumbs title={'Данные пользователя → Общая информация'} />
        <div className="pagePersonalContent">
            <div className="user-form-container">
                <div className="form-grid1">
                    <div className="form-column">
                        <div className="form-field">
                            <label>Имя*</label>
                            <div><input type="text" name="name" value={formData.name} onChange={handleInputChange} placeholder="Не указано"/></div>
                        </div>

                        <div className="form-field">
                            <label>Фамилия*</label>
                            <div><input type="text" name="family" value={formData.family} onChange={handleInputChange} placeholder="Не указано"/></div>
                        </div>

                        <div className="form-field">
                            <label>Телефон</label>
                            <div>
                                <input
                                    type="text"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    placeholder=""
                                    maxLength={13}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Кнопки */}
                <div className="allPagesStyleButton-posLeft">
                    <div className="allPagesStyleButton-group">
                        <div className="allPagesStyleButton" onClick={handleSave}>Сохранить</div>
                    </div>
                </div>

                {/* Уведомления */}
                {notification && (<Notification message={notification.message} type={notification.type} onClose={hideNotification} duration={3000}/>)}
            </div>
        </div>
    </div>
}

export default Personal

